"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipWrapper = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const TooltipWrapper = ({ children, title = children, isOpen, enterDelay, setIsOpen, }) => (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, open: isOpen, title: title, enterDelay: enterDelay, onClose: () => setIsOpen(false) }, children));
exports.TooltipWrapper = TooltipWrapper;
exports.default = exports.TooltipWrapper;
